module.exports = __webpack_public_path__ + "static/img/sspg_09.f26c1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sspg/sspg_09.jpg
// module id = jUXU
// module chunks = 1